import React from "react";
import { Pagination as BootstrapPagination, PaginationItem, PaginationLink } from "reactstrap";

function Pagination({
  pageNumber,
  pageSize,
  totalCount,
  totalPages,
  onPageChange,
}) {
  const getStartIndex = () => {
    return totalCount === 0 ? 0 : (pageNumber - 1) * pageSize + 1;
  };

  const getEndIndex = () => {
    const end = pageNumber * pageSize;
    return end > totalCount ? totalCount : end;
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (pageNumber <= 3) {
        for (let i = 2; i <= 4; i++) {
          pages.push(i);
        }
        pages.push("ellipsis");
        pages.push(totalPages);
      } else if (pageNumber >= totalPages - 2) {
        pages.push("ellipsis");
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push("ellipsis");
        for (let i = pageNumber - 1; i <= pageNumber + 1; i++) {
          pages.push(i);
        }
        pages.push("ellipsis");
        pages.push(totalPages);
      }
    }
    return pages;
  };

  if (totalCount === 0) return null;

  return (
    <div className="d-flex justify-content-between align-items-center px-3 mt-2">
        <span className="text-muted">
          Showing {getStartIndex()} - {getEndIndex()} of {totalCount} results
        </span>
      <BootstrapPagination className="mb-0">
        <PaginationItem disabled={pageNumber === 1}>
          <PaginationLink previous onClick={() => onPageChange(pageNumber - 1)} />
        </PaginationItem>
        {getPageNumbers().map((page, index) =>
          page === "ellipsis" ? (
            <PaginationItem key={`ellipsis-${index}`} disabled>
              <PaginationLink>...</PaginationLink>
            </PaginationItem>
          ) : (
            <PaginationItem key={page} active={page === pageNumber}>
              <PaginationLink onClick={() => onPageChange(page)}>
                {page}
              </PaginationLink>
            </PaginationItem>
          ),
        )}
        <PaginationItem disabled={pageNumber === totalPages}>
          <PaginationLink next onClick={() => onPageChange(pageNumber + 1)} />
        </PaginationItem>
      </BootstrapPagination>
    </div>
  );
}

export default Pagination;
